/**
 * Product card (mention) — ingredient pill row.
 * When the pills don't fit the card the row scrolls sideways: touch swipe and
 * trackpad work natively; this adds click-and-drag scrolling for a mouse.
 * Markup: snippets/product-card-mention.liquid
 */
if (!customElements.get('mention-ingredients')) {
  customElements.define(
    'mention-ingredients',
    class MentionIngredients extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('[data-ing-list]');
        if (!this.list) return;

        this.update = this.update.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        this.list.addEventListener('pointerdown', this.onPointerDown);
        // Swallow the click that ends a drag so it doesn't trigger anything
        this.list.addEventListener('click', (e) => {
          if (this.dragged) {
            e.preventDefault();
            e.stopPropagation();
            this.dragged = false;
          }
        }, true);
        this.list.addEventListener('dragstart', (e) => e.preventDefault());

        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(this.update);
          this.observer.observe(this.list);
        } else {
          window.addEventListener('resize', this.update);
        }
        // Fonts can change pill widths after first paint
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.update);
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.update);
      }

      update() {
        this.toggleAttribute('data-overflowing', this.list.scrollWidth - this.list.clientWidth > 1);
      }

      onPointerDown(e) {
        // Touch and pen scroll natively; only take over for a mouse
        if (e.pointerType !== 'mouse' || e.button !== 0 || !this.hasAttribute('data-overflowing')) return;
        this.startX = e.clientX;
        this.startScroll = this.list.scrollLeft;
        this.dragged = false;
        this.pointerId = e.pointerId;
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
        window.addEventListener('pointercancel', this.onPointerUp);
      }

      onPointerMove(e) {
        var dx = e.clientX - this.startX;
        if (!this.dragged && Math.abs(dx) < 4) return;
        if (!this.dragged) {
          this.dragged = true;
          this.setAttribute('data-dragging', '');
          try { this.list.setPointerCapture(this.pointerId); } catch (err) {}
        }
        this.list.scrollLeft = this.startScroll - dx;
      }

      onPointerUp() {
        this.removeAttribute('data-dragging');
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        window.removeEventListener('pointercancel', this.onPointerUp);
      }
    }
  );
}
